import { withNamespaces } from "react-i18next";
import { Spinner, Table } from "reactstrap";
import KYBCompanyContext from "../../../../../contexts/KYBCompanyContext";
import { useContext } from "react";
import { RiCheckLine, RiCloseLine } from "react-icons/ri";

const ListReportResult = ({ 
    t,
    serviceInfo
}) => {
    const {
        companyData,
        fetchDetailsQueries
    } = useContext(KYBCompanyContext);

    const {
        reports
    } = companyData;

    const searchColumns = serviceInfo.searchResultColumns || [];
    const serviceReportsQueries = fetchDetailsQueries.filter(q => q.serviceId === serviceInfo.id);
    const serviceReports = reports[serviceInfo.id] || [];

    return (
        <div
            style={{
                maxHeight: '400px',
                overflow: 'auto'
            }}
        >
            <Table bordered hover striped>
                <thead
                    style={{
                        position: 'sticky',
                        top: 0,
                        background: 'white',
                        zIndex: 2
                    }}
                >
                    <tr>
                        <th>
                            {t('Fetch Status')}
                        </th>

                        {searchColumns.map((col, colIndex) => {
                            return (
                                <th key={colIndex}>
                                    {t(col.title)}
                                </th>
                            )
                        })}
                    </tr>
                </thead>
                <tbody>
                    {serviceReports.map((report, reportIndex) => {
                        const reportDetailQuery = serviceReportsQueries.find((r) => r.id === `${serviceInfo.id}-${report.id}`);

                        return (
                            <tr key={reportIndex}>
                                <td>
                                    {reportDetailQuery.isFetching ? (
                                        <div>
                                            <Spinner size='sm' color="primary" className="me-1" />
                                            <span>{t('In Progress')}...</span>
                                        </div>
                                    ) : (
                                        reportDetailQuery.isSuccess ? (
                                            <span className="text-success">
                                                <RiCheckLine size={24} className="me-1" />
                                                {t('Completed')}
                                            </span>
                                        ) : (
                                            <span className="text-danger">
                                                <RiCloseLine size={24} className="me-1" />
                                                {t('Error')}
                                            </span>
                                        )
                                    )}
                                </td>

                                {searchColumns.map((col, colIndex) => {
                                    return (
                                        <td key={colIndex}>
                                            {col.formatter ? col.formatter(
                                                report[col.key],
                                                report,
                                                t
                                            ) : report[col.key]}
                                        </td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                </tbody>
            </Table>
        </div>
    )
}

export default withNamespaces()(
    ListReportResult
);